const get = require('lodash/get')
const {listBatches, purgeCache} = require('./api/batch-list')
const getBatch = require('./api/batch-get')
const onBatchListUpdated = require('./api/batch-on-list-updated')
const getOrList = require('./api/get-or-list-batch')
const upsert = require('./api/upsert')
const listManufacturers = require('./api/batch-list-manufacturers')
const newBatch = require('./api/batch-new')
const getProductNonExpiredBatches = require('./api/get-product-non-expired-batches')
const getExpiredBatchIds = require('./api/get-expired-batch-ids')
const missingBatches = require('./api/batch-missing')
const { wrapEntityApi } = require('../utils/wrap-api')

const rawMethods = {
  new: newBatch,
  list: listBatches,
  _purgeCache: purgeCache,
  listManufacturers: listManufacturers,
  onListUpdated: onBatchListUpdated,
  missing: missingBatches,
  get: getBatch
}

class BatchApi {
  constructor (state, mainApi, agaveAdapter) {
    const apiMethods = wrapEntityApi(rawMethods, state)
    Object.assign(this, apiMethods)
    this.mainApi = mainApi
    this.state = state
    this.agaveAdapter = agaveAdapter
  }

  // Fetch batches from the shared remote DB via agave. Used as a fallback when
  // the local (per-user) DB doesn't hold the batch docs — e.g. retailer
  // delivery statements, where batches are never synced into the user DB.
  // Mirrors product.getProductsViaIds.
  getBatchesViaIds (ids) {
    if (this.agaveAdapter) {
      return this.agaveAdapter.create('batch/by-ids', { ids })
    }
    // Fallback to local pouch
    return listBatches(this.state, { ids })
  }

  // Called by the NHLMIS (PSM) REST API
  getOrList (queryParams, alias) {
    return getOrList(
      this.mainApi,
      { ...queryParams, userPrograms: get(this.state, 'user.programs', []) },
      alias
    )
  }

  // Called by the NHLMIS (PSM) REST API
  upsert (batch, alias, updatedAliasId) {
    return upsert(this.mainApi, batch, alias, updatedAliasId)
  }

  getNonExpired (productIds) {
    return getProductNonExpiredBatches(this.mainApi.state, productIds)
  }

  getExpiredBatchIds (batchIds, date) {
    return getExpiredBatchIds(this.mainApi.state, batchIds, date)
  }
}

module.exports = rawMethods
module.exports.BatchApi = BatchApi
